.collapsible {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.triggerWrap {
  margin-right: auto;
  background: var(--m-gray-paper);
  border-top-left-radius: var(--m-rd-sm);
  border-top-right-radius: var(--m-rd-sm);

  &:has([aria-expanded='false']) {
    border-bottom-left-radius: var(--m-rd-sm);
    border-bottom-right-radius: var(--m-rd-sm);
  }
}

.content {
  background: var(--m-gray-paper);
}

.filterLabel {
  display: flex;
  align-items: center;
  gap: var(--m-sp-xs);
  cursor: pointer;
}

.gameGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--m-sp-md);
  padding: var(--m-sp-md);

  @media (min-width: 640px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (min-width: 768px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.emptyState {
  color: var(--m-gray-heavy);
}

.item {
  aspect-ratio: 1;
  min-width: --fn-literal(80px);
}

.selected {
  box-shadow: 0 0 0 --fn-literal(6px) var(--m-accent-heavy);
}

.title {
  font-size: var(--m-fs-sm);

  @media (min-width: 768px) {
    font-size: var(--m-fs-md);
  }
}

.actionButton {
  width: 100%;
  justify-content: center;
}
